import { useMutation } from "@tanstack/react-query";
import { getReport } from "../../queries/ScheduleHub";

interface IGetHubReportParams {
  idCronograma: string;
  period: 'week' | 'month' | 'general';
}

export const useGetHubReport = () => {
  const { data, isPending, isError, mutate } = useMutation({
    mutationKey: ['getHubReport'],
    mutationFn: (params: IGetHubReportParams) => getReport(params.idCronograma, params.period),
    retry: false,
  });

  return { mutate, isPending, isError, data };
};